module.exports = "<div class =\"footer\">\r\n    <div >&copy; {{year}} Mercedes-Benz AG. All rights reserved.</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common-footer/common-footer.template.html
// module id = ./src/app/components/common-footer/common-footer.template.html
// module chunks = main